import usePlacesAutocomplete, {
  getGeocode,
  getLatLng,
  getZipCode,
} from "use-places-autocomplete";
import {
  Combobox,
  ComboboxInput,
  ComboboxPopover,
  ComboboxList,
  ComboboxOption,
} from "@reach/combobox";
import "@reach/combobox/styles.css";

import classes from "./Maps.module.css";
import Fonts from "../../stories/assets/Fonts";
import Colors from "../../stories/assets/Colors";

export default function Places({
  setCoordinates,
  setAddress,
  label,
  placeholder = "Search address",
  className,
  setPlaceDetail,
}) {
  const {
    ready,
    value,
    setValue,
    suggestions: { status, data },
    clearSuggestions,
  } = usePlacesAutocomplete();

  //   handleSelect
  const handleSelect = async (val) => {
    setValue(val, false);
    clearSuggestions();

    const results = await getGeocode({ address: val });
    const zipcode = await getZipCode(results[0], false);
    const { lat, lng } = await getLatLng(results[0]);

    let country = "";
    let city = "";
    let state = "";

    let addrComp = results[0].address_components;
    for (let i = 0; i < addrComp.length; ++i) {
      if (addrComp[i].types.includes("administrative_area_level_1"))
        state = addrComp[i].long_name;
      else if (addrComp[i].types.includes("locality"))
        city = addrComp[i].long_name;
      else if (addrComp[i].types.includes("country"))
        country = addrComp[i].long_name;
      //we can break early if we find all three data
      if (state != "" && city != "" && country != "") break;
    }
    setPlaceDetail && setPlaceDetail({ state, city, country, zipcode });
    setCoordinates({ lat, lng });
    setAddress(val);
  };

  return (
    <Combobox
      onSelect={handleSelect}
      className={`${className ? className : ""}`}
    >
      {label && (
        <label
          className={`mb-2  ${[classes.labelText].join(" ")}`}
          style={{
            ...Fonts.input2,
            color: Colors.neutralShadesOfNero,
            lineHeight: "16px",
          }}
        >
          {label}
        </label>
      )}
      <ComboboxInput
        value={value}
        onChange={(e) => setValue(e.target.value)}
        disabled={!ready}
        className={classes["combobox-input"]}
        placeholder={placeholder}
      />
      <ComboboxPopover style={{ zIndex: "99999" }}>
        <ComboboxList>
          {status === "OK" &&
            data.map(({ place_id, description }) => (
              <ComboboxOption key={place_id} value={description} />
            ))}
        </ComboboxList>
      </ComboboxPopover>
    </Combobox>
  );
}
